

import { fetchTasks } from '../store/reducers/tasksReducer';
import tokenManager from './tokenManager';
import {
  fetchState,
  fetchAccounting, 
  fetchBindingErrors,
  fetchConclusions,
  fetchMounted,
  fetchRules,
  fetchSpecs,
  fetchSpecsNew,
  fetchUser, 
  fetchProjects,
  fetchUsersSettings } from '../store/reducers/stateReducer';

/**
 * Менеджер для управления загрузкой и обновлением данных приложения
 */
class DataManager {
  constructor() {
    this.intervals = new Map();
    this.isInitialized = false;
  }

  /**
   * Инициализация менеджера данных
   * @param {Object} dispatch - Redux dispatch функция
   * @param {Object} auth - Объект авторизации
   */
  initialize(dispatch, auth) {
    if (this.isInitialized) return;
    
    this.dispatch = dispatch;
    this.auth = auth;
    this.isInitialized = true;
    
    console.log('🔄 DataManager инициализирован');
    console.log(auth.user)
  }

  /**
   * Загрузка пользователя
   * @param {string} accessToken - Токен доступа
   * @param {string} username - Имя пользователя
   */
  loadUser(accessToken, username) {
    console.log('👤 Загрузка данных пользователя');
    this.dispatch(fetchUser(accessToken, username));
  }

  /**
   * Первоначальная загрузка всех данных
   */
  loadInitialData() {
    console.log('📡 Выполняется первоначальная загрузка API данных');
    
    this.dispatch(fetchState());
    this.dispatch(fetchProjects());
    this.dispatch(fetchAccounting());
    this.dispatch(fetchSpecs());
    this.dispatch(fetchSpecsNew());
    this.dispatch(fetchMounted());
    this.dispatch(fetchTasks());
    this.dispatch(fetchConclusions());
    this.dispatch(fetchRules());
    this.dispatch(fetchBindingErrors());
    this.dispatch(fetchUsersSettings());
  }

  /**
   * Регулярное обновление данных
   */
  refreshData() {
    console.log('📡 Выполняется регулярное обновление данных по интервалу');
    
    this.dispatch(fetchState());
    this.dispatch(fetchProjects());
    this.dispatch(fetchAccounting());
    this.dispatch(fetchSpecs());
    this.dispatch(fetchSpecsNew());
    this.dispatch(fetchMounted());
    this.dispatch(fetchTasks());
    this.dispatch(fetchConclusions());
    this.dispatch(fetchRules());
    this.dispatch(fetchBindingErrors());
    this.dispatch(fetchUsersSettings());
  }

  /**
   * Проверка статуса при ошибках
   */
  checkStatusOnError() {
    console.log('📡 Выполняется проверка статуса при ошибке');
    
    this.dispatch(fetchState());
    this.dispatch(fetchProjects());
    this.dispatch(fetchSpecs());
    this.dispatch(fetchSpecsNew());
    this.dispatch(fetchMounted());
    this.dispatch(fetchTasks());
    this.dispatch(fetchConclusions());
    this.dispatch(fetchRules());
    this.dispatch(fetchBindingErrors());
    this.dispatch(fetchUsersSettings());
  }

  /**
   * Установка интервала для регулярного обновления данных
   * @param {number} intervalMs - Интервал в миллисекундах (по умолчанию 5 минут)
   */
  startRegularRefresh(intervalMs = 300000) {
    if (this.intervals.has('regular')) {
      this.stopRegularRefresh();
    }

    console.log(`⏰ Установка интервала для регулярного обновления данных (${intervalMs / 1000} секунд)`);
    
    const interval = setInterval(() => {
      this.refreshData();
    }, intervalMs);

    this.intervals.set('regular', interval);
  }

  /**
   * Остановка интервала регулярного обновления
   */
  stopRegularRefresh() {
    const interval = this.intervals.get('regular');
    if (interval) {
      console.log('🧹 Очистка интервала регулярного обновления');
      clearInterval(interval);
      this.intervals.delete('regular');
    }
  }

  /**
   * Установка интервала для проверки статуса при ошибках
   * @param {number} intervalMs - Интервал в миллисекундах (по умолчанию 1 минута)
   */
  startErrorStatusCheck(intervalMs = 60000) {
    if (this.intervals.has('errorCheck')) {
      this.stopErrorStatusCheck();
    }

    console.log(`⚠️ Установка интервала для проверки статуса при ошибках (${intervalMs / 1000} секунд)`);
    
    const interval = setInterval(() => {
      this.checkStatusOnError();
    }, intervalMs);

    this.intervals.set('errorCheck', interval);
  }

  /**
   * Остановка интервала проверки статуса при ошибках
   */
  stopErrorStatusCheck() {
    const interval = this.intervals.get('errorCheck');
    if (interval) {
      console.log('🧹 Очистка интервала проверки статуса');
      clearInterval(interval);
      this.intervals.delete('errorCheck');
    }
  }

  /**
   * Остановка всех интервалов
   */
  stopAllIntervals() {
    console.log('🧹 Очистка всех интервалов обновления данных');
    
    this.intervals.forEach((interval, key) => {
      clearInterval(interval);
      console.log(`🧹 Очищен интервал: ${key}`);
    });
    
    this.intervals.clear();
  }

  /**
   * Сброс состояния менеджера
   */
  reset() {
    this.stopAllIntervals();
    this.isInitialized = false;
    console.log('🔄 DataManager сброшен');
  }

  /**
   * Получение информации о текущих интервалах
   */
  getIntervalsInfo() {
    const info = {};
    this.intervals.forEach((interval, key) => {
      info[key] = 'active';
    });
    return info;
  }
}

// Создаем единственный экземпляр менеджера данных
const dataManager = new DataManager();

export default dataManager; 